export class OccDeviation
{
	occDeviationId?: number;
	createDate?: string;
	lastUpdate?: string;
	lowEndExpOccPCT?: number;
	highEndExpOccPCT?: number;
	occProfileId?: number;
}
